import { useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { TrashIcon, PlusCircleIcon } from "@heroicons/react/24/outline"
import { setBAndCRaces } from "redux/slices/generator"
import moment from 'moment'

export default function BAndCRaceInput() {

    const dispatch = useDispatch()
    const bAndCRaces = useSelector((state) => state.generator.inputs.bAndCRaces)
    
    // B and C Race variables
    const [newEventName, setNewEventName] = useState('New Event')
    const HandleNewEventNameChange = (event) => setNewEventName(event.target.value)

    const [newEventType, setNewEventType] = useState('b-race')
    const HandleNewEventTypeChange = (event) => setNewEventType(event.target.value)

    const [newEventDate, setNewEventDate] = useState(moment().utc().local().format('YYYY-MM-DD'))
    const HandleNewEventDateChange = (event) => setNewEventDate(event.target.value)

    const AddEvent = () => {
        const newEventJSON = {
            id: 1,
            name: newEventName,
            eventType: newEventType,
            eventTrainingStartDate: newEventDate,
            eventDate: newEventDate,
            deloadAfterEvent: 0,
            programEndDate: newEventDate
        }

        // console.log(newEventJSON); return;

        var tempEvents = JSON.parse(JSON.stringify(bAndCRaces))

        tempEvents.push(newEventJSON)

        // console.log(tempEvents);

        dispatch(setBAndCRaces(tempEvents))
    }

    const RemoveEvent = (index) => {
        var tempEvents = JSON.parse(JSON.stringify(bAndCRaces))
        tempEvents.splice(index, 1)
        dispatch(setBAndCRaces(tempEvents))
    }
        
    return (
        <div className="border-t border-l border-gray-400">
            <div className="flex border-b border-gray-400 font-semibold bg-gray-50 text-sm">
                <div className="flex-1 p-2 border-r border-gray-400">Event Name</div>

                <div className="flex-1 p-2 border-r border-gray-400">Event Type</div>

                <div className="flex-1 p-2 border-r border-gray-400">Event Date</div>

                <div className="w-10 border-r border-gray-400" />
            </div>

            {/* Added Events */}
            {bAndCRaces.length > 0 && (
                <>
                    {bAndCRaces.map((event, index) => (
                        <div key={index} className="flex border-b border-gray-400">
                            <div className="flex-1 p-2 border-r border-gray-400">{event.name}</div>

                            <div className="flex-1 p-2 border-r border-gray-400">{event.eventType}</div>

                            <div className="flex-1 p-2 border-r border-gray-400">{event.eventDate}</div>

                            <div className="w-10 p-2.5 border-r border-gray-400 text-gray-600 cursor-pointer hover:text-gray-800" onClick={() => RemoveEvent(index)}>
                                <TrashIcon className="h-5" />
                            </div>
                        </div>
                    ))}
                </>
            )}

            {/* New Event Component */}
            <div className="flex border-b border-gray-400">
                <div className="flex-1 border-r border-gray-400">
                    <input type="text" name="eventName" id="eventName" placeholder="Event Name" className="w-full p-2" value={newEventName} onChange={HandleNewEventNameChange} />
                </div>

                <div className="flex-1 border-r border-gray-400">
                    <select id="sport" value={newEventType} onChange={HandleNewEventTypeChange} className="w-full p-2 cursor-pointer">
                        <option value="b-race">B Race</option>
                        <option value="c-race">C Race</option>
                    </select>
                </div>

                <div className="flex-1 border-r border-gray-400">
                    <input type="date" name="birthday" id="birthday" placeholder="Event Date*" value={newEventDate} onChange={HandleNewEventDateChange} className="w-full p-2 cursor-pointer" />
                </div>

                <div className="w-10 p-2.5 border-r border-gray-400 text-gray-600 cursor-pointer hover:text-gray-800" onClick={() => AddEvent()}>
                    <PlusCircleIcon className="h-5" />
                </div>
            </div>
        </div>
    )
    
}